import { array } from "prop-types";
import React, { useState, useEffect } from "react";
import { Form, Grid, Card, Table, Alert, Button, Icon, Dimmer, Tab } from "tabler-react";

export const ContentReportesGenerales = ({ data, sinColumnas, opciones }) => {
	const [headers, setHeaders] = useState([]);
	const [content, setContent] = useState([]);

	useEffect(() => {
		if (data !== undefined) {
			let bool = true;
			let headers = [];
			let content = [];
			
			// Verificar si alguna plataforma seleccionada es 61 o 1316
			const plataformasEspeciales = opciones?.tempPlataformaN?.some(p => p.value === 61 || p.value === 1316 || p.value === 1711);
			
			data.content.forEach((row, index) => {
				let columnas = [];
				Object.entries(JSON.parse(row)).forEach(([key, columna]) => {
					if (!sinColumnas.includes(key)) {
						if (bool) {
							// Cambiar título si es la columna específica y plataforma correcta
							let titulo = key;
							if (plataformasEspeciales) {
								if (key === 'arribo_direcion_carga') {
									titulo = 'Llegada de Unidad a centro de carga';
								} else if (key === 'reporte_centro_carga') {
									titulo = 'Reporte de Operador / reporte en centro de carga';
								} else if (key === 'asignacion_cortina_centro_carga') {
									titulo = 'Asignación de Cortina en centro carga';
								} else if (key === 'inicio_de_carga') {
									titulo = 'Inicio de carga';
								} else if (key === 'cita_programada') {
									titulo = 'Cita en cliente';
								} else if (key === 'inicio_ruta') {
									titulo = 'Salida de Centro de Carga/Inicio de ruta';
								} else if (key === 'arribo_cliente_lleno') {
									titulo = 'Llegada a Cliente';
								} else if (key === 'hora_maxima_salida') {
									titulo = 'Hora de máxima salida';
								} else if (key === 'fin_de_carga') {
									titulo = 'Fin de carga';
								} else if (key === 'entrega_documentos_control_tower') {
									titulo = 'Entrega de documentos a control tower';
								} else if (key === 'entrega_documentos') {
									titulo = 'Entrega de documentos en cliente';
								} else if (key === 'asignacion_rampa') {
									titulo = 'Asignación de Rampa';
								} else if (key === 'inicio_de_descarga') {
									titulo = 'Inicio de Descarga';
								} else if (key === 'entrega_de_pods') {
									titulo = 'Entrega de PODs';
								} else if (key === 'fin_de_descarga') {
									titulo = 'Fin de Descarga';
								} else if (key === 'cita_programada_terminal') {
									titulo = 'Cita en centro carga';
								}
							}
							headers.push(<th>{titulo}</th>);
						}
						columnas.push(<Table.Col>{columna}</Table.Col>);
					}
				});
				bool = false;
				content.push(<Table.Row>{columnas}</Table.Row>);
			});
			setHeaders(headers);
			setContent(content);
		}
	}, [data]);

	return (
		<div>
			{content.length > 0 ? (
				<Table
					cards={true}
					striped={true}
					responsive={true}
					className="table-center col-12 table-bordered"
					style={{ color: "black", fontSize: "80%" }}
				>
					<Table.Header className="thead-dark">
						<tr>{headers}</tr>
					</Table.Header>
					<Table.Body>{content}</Table.Body>
				</Table>
			) : (
				<div className="alert alert-dark w-100 mt-6" role="alert">
					No hay resultados que mostrar...
				</div>
			)}
		</div>
	);
};
